export default __webpack_public_path__ + "static/media/me.7bf69b0a.svg";